import cn from 'classnames';
import { FC } from 'react';
import { BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { IconButton } from '../icon-button/icon-button';
import s from './slider.module.css';
import { SliderProps, useSlider } from './use-slider/use-slider';

export const Slider: FC<SliderProps> = (props) => {
  const {
    className,
    currentIndex,
    dragOffset,
    dragging,
    elements,
    handleDragEnd,
    handleMouseDown,
    handleMouseMove,
    handleNext,
    handlePrev,
    handleTouchEnd,
    handleTouchMove,
    handleTouchStart,
    isExistNext,
    isExistPrev,
    other,
    slideMaxWidth,
    slideGap,
  } = useSlider(props);

  return (
    <div className={cn(s.component, className)} {...other}>
      <ul
        className={s.slides}
        style={{
          transform: `translateX(calc(-${currentIndex * 100}% + ${dragging ? dragOffset : 0}px))`,
          transition: dragging ? 'none' : 'transform 0.3s ease-in-out',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleDragEnd}
        onMouseLeave={handleDragEnd}
      >
        {elements.map((slides, index) => (
          <li key={index} className={s.item} style={{ gap: slideGap }}>
            {slides?.map((child, i) => (
              <div key={i} className={s.slide} style={{ maxWidth: slideMaxWidth }}>
                {child}
              </div>
            ))}
          </li>
        ))}
      </ul>
      {isExistPrev && (
        <IconButton className={s.left} onClick={handlePrev}>
          <BiArrowToLeft />
        </IconButton>
      )}
      {isExistNext && (
        <IconButton className={s.right} onClick={handleNext}>
          <BiArrowToRight />
        </IconButton>
      )}
    </div>
  );
};
